import { useEffect, useState } from 'react';

const checkoutBase = (process.env.REACT_APP_JEDDLE_BASE_URL ?? 'https://jeddle.duxdigital.net').replace(/\/+$/, '');

export const formatUpgradePrice = (price, cycle) => {
  const period = cycle === 'annually' ? 'year' : 'month';
  if (!price || !Number.isFinite(price.amount) || price.amount < 0 || price.period !== period || price.interval !== 1 || !/^[A-Z]{3}$/.test(price.currency)) return null;
  const format = amount => new Intl.NumberFormat('en-AU', { style: 'currency', currency: price.currency, maximumFractionDigits: 2, minimumFractionDigits: Number.isInteger(amount) ? 0 : 2 }).format(amount);
  return {
    headline: `${format(cycle === 'annually' ? price.amount / 12 : price.amount)}/mo`,
    billing: `Billed ${format(price.amount)} ${price.currency} ${cycle === 'annually' ? 'annually' : 'monthly'}`,
  };
};

export default function useUpgradePrices(isOpen) {
  const [plans, setPlans] = useState({});
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [attempt, setAttempt] = useState(0);
  useEffect(() => {
    if (!isOpen) return undefined;
    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), 10000);
    let active = true;
    setLoading(true);
    setError(false);
    setPlans({});
    // The query string keeps Kinsta's server cache (which ignores Cache-Control) from serving stale prices.
    fetch(`${checkoutBase}/wp-json/jeddle/v1/upgrade-prices?_=${Date.now()}`, { signal: controller.signal, credentials: 'omit', cache: 'no-store' })
      .then(response => {
        if (!response.ok) throw new Error('Prices unavailable');
        return response.json();
      })
      .then(data => { if (active) setPlans(data.plans || {}); })
      .catch(() => { if (active) setError(true); })
      .finally(() => { if (active) setLoading(false); clearTimeout(timeout); });
    return () => { active = false; controller.abort(); clearTimeout(timeout); };
  }, [isOpen, attempt]);
  return { loading, error, retry: () => setAttempt(value => value + 1), price: (plan, cycle) => formatUpgradePrice(plans[plan]?.[cycle], cycle) };
}
